import './Spinner.styled.scss'

export const Spinner = () => (
  <div className="spinnerWrapper">
    <span className="spinner" />
  </div>
)
